import { combineReducers } from 'redux';
import options from './options/reducer';

export default combineReducers({ options });
